export const MENU_ITEMS = [
  {
    label: "Anslagstavlan",
    url: "#/anslagstavlan",
  },
  {
    label: "Lämna önskeuppdrag",
    url: "#/uppdrag",
  },
  {
    label: "Min profil",
    url: "#/profile",
  },
];

export const MENU_ADMIN_ITEMS = [
  {
    label: "Kompetenser [admin]",
    url: "#/admin-competences",
  },  {
    label: "Sök [admin]",
    url: "#/admin-search",
  },
];

export const TXT_SUBTITLE="Här kan du se hur eftertraktad din profil är som egenkonsult.";
